// extracted by mini-css-extract-plugin
export default {"label":"RadioGroupComponent_label__7yqRP"};